import { HashRouter, Route, Routes, Navigate } from 'react-router-dom';
import AlfonsBC from './AlfonsBC';
import './App.css';
import {HelmetProvider} from 'react-helmet-async';
function App() {
  return (
    <HelmetProvider>
    <HashRouter>
      <div>
        <Routes>
          <Route path="/*" element={ <AlfonsBC/>} />
        </Routes>
      </div>
    </HashRouter>
    </HelmetProvider>
  );
}

export default App;
